import React from 'react'

import intervalChoiceValues from '../misc/intervalChoiceValues'
import intervalChoiceUnits from '../misc/intervalChoiceUnits'
import {
  Select,
} from '../../styles/forms'

const IntervalChooser = () => (
  <div>
    every
    {' '}
    <Select name="intervalValue">
      <option key='' value=''>...</option>
      {intervalChoiceValues.map(value => (
        <option key={value} value={value}>{value}</option>
      ))}
    </Select>
    <Select name="intervalUnit">
      <option key='' value=''>...</option>
      {intervalChoiceUnits.map(unit => (
        <option key={unit.id} value={unit.id}>{unit.nameAmbiguous}</option>
      ))}
    </Select>
  </div>
)

export default IntervalChooser



// WEBPACK FOOTER //
// ./src/views/personNew/IntervalRadios.js